import { Link } from 'react-router-dom'
import React , {useState ,useEffect} from 'react'
import Pricing from '../HomeMain/Pricing/Main'
import Bredcrumb from '../Bredcrumb/Main'
import BGImg from "../../assets/images/bread_crumb_bg.png"
import BGImg1 from "../../assets/images/bread_crumb_bg_one.png"
import BGImg2 from "../../assets/images/bread_crumb_bg_two.png"


const Main = ({brdcum}) => {
    const[activeFaq, setActiveFaq] = useState({a : true})
    
  return (
    <>
        {brdcum.b1 && 
        <Bredcrumb 
        no={1}
        title="Our Pricing & Plans" 
        paragraph="We provide tiered pricing, the more you track the bigger the discount!"
        tag="Our Pricing & Plans" 
        bgimg={BGImg}/>}


        <Pricing/>
    </>
  )
}

export default Main